<div *ngIf="users && users.length">
    <div >
        <table class="table">
            <thead>
                <tr>
                    <th>User</th>
                    <th>Pcc Status</th>
                    <th>Update</th>
                    <th>Password</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let user of users">
                    <td>{{ user.privateName }}</td>
                    <td>{{ '' }}</td>
                    <td><button (click)="saveMetaAsExtra(user)">Update PCC in extra</button></td>
                    <td>{{ user.message }}</td>
                </tr>
            </tbody>
        </table>
</div>